import { Link } from 'react-router-dom'
import Logo from '@/components/Logo'

const columns = [
  {
    title: 'Colaboradores',
    links: [
      { label: 'Buscar empleos', to: '/empleos' },
      { label: 'Capacitaciones', to: '/capacitaciones' },
      { label: 'Perfil profesional', to: '/registro' },
    ],
  },
  {
    title: 'Empresas',
    links: [
      { label: 'Publicar vacante', to: '/registro' },
      { label: 'Buscar talento', to: '/empresas' },
      { label: 'Evaluaciones', to: '/como-funciona' },
    ],
  },
  {
    title: 'Plataforma',
    links: [
      { label: 'Cómo funciona', to: '/como-funciona' },
      { label: 'Reputación laboral', to: '/como-funciona' },
      { label: 'Iniciar sesión', to: '/login' },
    ],
  },
]

function Footer() {
  return (
    <footer className="border-t border-slate-800 bg-slate-950 text-slate-300">
      <div className="mx-auto max-w-7xl px-4 py-14 sm:px-6 lg:px-8">
        <div className="grid gap-10 md:grid-cols-4">
          <div>
            <Logo variant="light" />
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-slate-400">
              Todo tu crecimiento profesional en un solo lugar: conecta con empresas, desarrolla tus habilidades y construye una reputación laboral que te represente.
            </p>
          </div>
          {columns.map((col) => (
            <div key={col.title}>
              <h4 className="text-sm font-semibold text-white">{col.title}</h4>
              <ul className="mt-4 space-y-3">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <Link to={link.to} className="text-sm text-slate-400 transition-colors hover:text-amber-400">
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-12 border-t border-slate-800 pt-6 text-sm text-slate-500">
          © {new Date().getFullYear()} Beeznz Work. Todos los derechos reservados.
        </div>
      </div>
    </footer>
  )
}

export default Footer
